import { Record, type RecordOf } from 'immutable';

export type ChipType = 'user' | 'event' | 'text' | 'date';

export interface ChipProps {
  label: string;
  value: string;
  picture?: string | null;
  type: ChipType;
}

export type Chip = RecordOf<ChipProps>;

export const OptionUserFactory = Record<ChipProps>({
  label: '',
  value: '',
  picture: null,
  type: 'user',
});

export const OptionEventFactory = Record<ChipProps>({
  label: '',
  value: '',
  picture: null,
  type: 'event',
});

export const ChipTextFactory = Record<ChipProps>({
  label: '',
  value: '',
  picture: null,
  type: 'text',
});

export const ChipDateFactory = Record<ChipProps>({
  label: '',
  value: '',
  picture: null,
  type: 'date',
});
